import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function Industries() {
  const navigate = useNavigate();

  const industries = [
    {
      img: "/assets/newid1.jpg",
      title: "Landscape",
      desc: "Supporting the outdoor lighting to enhance the beauty, safety and functionality of the gardens, pathways, water and architectural features.",
      link: "/landscape",
    },
    {
      img: "/assets/newid2.jpg",
      title: "Oil & Gas",
      desc: "Driving innovation and costefficiency electrical & instrumentation solutions.",
      link: "/oilgas",
    },
    {
      img: "/assets/newid3.jpg",
      title: "Solar",
      desc: "UV-resistant cable management, enclosing, termination and labelling solutions.",
      link: "/solar",
    },
    {
      img: "/assets/in6.jpg",
      title: "Utilities",
      desc: "Enclosure, termination and identification solutions for power, water and gas infrastructure",
      link: "/utilities",
    },
    {
      img: "/assets/project/img13.jpg",
      title: "Construction",
      desc: "Sturdy and build to last, cable management and termination systems",
      link: "/construction",
    },
    {
      img: "/assets/newid.jpg",
      title: "Industrial",
      desc: "Integrated solutions for machinery, automation, and heavy-duty manufacturing environments.",
      link: "/industrial",
    },
  ];

  return (
    <>
      {/* Hero Section */}
        <Helmet>
        <title>
          Industries We Serve | Electrical & Cable Solutions UAE | Al Ibtekar
        </title>

        <meta
          name="description"
          content="Al Ibtekar provides cable management, cable termination, electrical and instrumentation solutions for landscape, oil & gas, solar, utilities, construction and industrial applications across the UAE."
        />

        <meta
          name="keywords"
          content="industries served UAE, cable management UAE, cable termination UAE, oil and gas electrical solutions UAE, solar cable management UAE, utility electrical solutions UAE, construction cable management UAE, industrial electrical solutions UAE, E&I solutions UAE"
        />

        <meta
          name="robots"
          content="index, follow"
        />

        <link
          rel="canonical"
          href="https://saig.me/industries"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Industries We Serve | Electrical & Cable Solutions UAE | Al Ibtekar"
        />

        <meta
          property="og:description"
          content="Explore Al Ibtekar's industry-specific cable management, termination, electrical and instrumentation solutions for oil & gas, solar, utilities, construction, landscape and industrial applications."
        />

        <meta
          property="og:url"
          content="https://saig.me/industries"
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:site_name"
          content="Al Ibtekar"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Industries We Serve | Electrical & Cable Solutions UAE | Al Ibtekar"
        />

        <meta
          name="twitter:description"
          content="Industry-specific cable management, cable termination and electrical solutions for oil & gas, solar, utilities, construction, landscape and industrial sectors in the UAE."
        />
      </Helmet>
      <div className='newbanner-about newbanner-about3'>
        <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
          <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Industries We Serve</h6>
          <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">We deliver field-tested results where it matters most.
          </p>
        </div>
      </div>
      {/* <div className="mt-[91px] overflow-hidden relative">
        <img src="/assets/service/bg2.png" className='w-full lg:h-auto h-[300px] object-cover' alt="	Trusted cable management and termination solutions provider in the UAE" />
        <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto left-1/2 -translate-x-1/2 lg:px-[50px] px-[20px]">
          <h6 className="font-[500] font-kanit lg:text-[70px] text-[30px] text-white">Industries We Serve</h6>
          <p className="max-w-[582px] font-inter text-white">We deliver field-tested results where it matters most.</p>
        </div>
        <h1 className='absolute font-kanit lg:text-[180px] text-[60px] text-[#FFFFFF4F] right-[0px] bottom-[40px]'>Industries</h1>
      </div> */}

      {/* Grid Section */}


      <div
        className='indu-cards'
      >
        {industries.map((industry, index) => (

          <div className='indu-card' key={index}

            onClick={() => navigate(industry.link)}>
            <img src={industry.img} alt='industries' />


            <div className='indu-card-text'>

              <h3>{industry.title}</h3>
              <p>{industry.desc}</p>
            </div>

         
          </div>
        ))}
      </div>

    </>




  );
}

export default Industries;
